var map = {
	"./backgrounds/bottom.webp": 9148,
	"./backgrounds/fill.webp": 6843,
	"./backgrounds/left.webp": 480,
	"./backgrounds/right.webp": 9365,
	"./backgrounds/top.webp": 9490,
	"./css/fonts/LavishlyYours-Regular.ttf": 5897,
	"./css/fonts/SEGOEPR.TTF": 7751,
	"./css/fonts/SEGOEPRB.TTF": 6506,
	"./css/global.less": 4499,
	"./css/hexagons.css": 2585,
	"./css/transitions.less": 287,
	"./css/variables.less": 4795,
	"./flags/en.png": 749,
	"./flags/ro.png": 4481,
	"./others/header.png": 7381,
	"./others/inv_en.webp": 9958,
	"./others/inv_ro.webp": 9288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;